import { msg } from '@lingui/macro';

export default {
  title: msg`What brings you here today?`,
  intro: msg`Select the option that best describes your situation.`,
};
